<template>
  <span>
    Has Attached Images
  </span>
</template>
<script>

export default {
  name: 'ImageAttached',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
